"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calendarShortcuts = exports.calendarMoveShortcuts = exports.calendarBaseShortcuts = void 0;

var _datetime = _interopRequireDefault(require("./datetime.js"));

var calendarBaseShortcuts = [{
  text: '今天',
  onClick: function onClick(picker) {
    var startTime = new _datetime.default(new _datetime.default().setHours(0, 0, 0));
    var endTime = new _datetime.default(new _datetime.default().setHours(23, 59, 59));
    picker.$emit('pick', [startTime, endTime]);
  }
}, {
  text: '昨天',
  onClick: function onClick(picker) {
    var startTime = new _datetime.default(new _datetime.default().daysAgo(1).setHours(0, 0, 0));
    var endTime = new _datetime.default(new _datetime.default().daysAgo(1).setHours(23, 59, 59));
    picker.$emit('pick', [startTime, endTime]);
  }
}, {
  text: '最近一周',
  onClick: function onClick(picker) {
    var startTime = new _datetime.default(new _datetime.default().daysAgo(7).setHours(0, 0, 0));
    var endTime = new _datetime.default(new _datetime.default().setHours(23, 59, 59));
    picker.$emit('pick', [startTime, endTime]);
  }
}, {
  text: '最近30天',
  onClick: function onClick(picker) {
    var startTime = new _datetime.default(new _datetime.default().daysAgo(30).setHours(0, 0, 0));
    var endTime = new _datetime.default(new _datetime.default().setHours(23, 59, 59));
    picker.$emit('pick', [startTime, endTime]);
  }
}, {
  text: '这个月',
  onClick: function onClick(picker) {
    var startTime = new _datetime.default(new _datetime.default().monthBegin().setHours(0, 0, 0));
    var endTime = new _datetime.default(new _datetime.default().setHours(23, 59, 59));
    picker.$emit('pick', [startTime, endTime]);
  }
}, {
  text: '本季度',
  onClick: function onClick(picker) {
    var startTime = new _datetime.default(new _datetime.default().quarterBegin().setHours(0, 0, 0));
    var endTime = new _datetime.default(new _datetime.default().setHours(23, 59, 59));
    picker.$emit('pick', [startTime, endTime]);
  }
}];
exports.calendarBaseShortcuts = calendarBaseShortcuts;
var calendarMoveShortcuts = [{
  text: '‹ 往前一天 ',
  onClick: function onClick(picker) {
    var startTime = new _datetime.default(new _datetime.default().daysAgo(1).setHours(0, 0, 0));
    var endTime = new _datetime.default(new _datetime.default().daysAgo(1).setHours(23, 59, 59));

    if (!picker.value) {
      picker.value = [startTime, endTime];
    }

    startTime = picker.value[0].daysAgo(1);
    endTime = picker.value[1].daysAgo(1);
    picker.$emit('pick', [startTime, endTime]);
  }
}, {
  text: ' 往后一天 ›',
  onClick: function onClick(picker) {
    var startTime = new _datetime.default(new _datetime.default().setHours(0, 0, 0));
    var endTime = new _datetime.default(new _datetime.default().setHours(23, 59, 59));

    if (!picker.value) {
      picker.value = [startTime, endTime];
    }

    startTime = picker.value[0].daysAgo(-1);
    endTime = picker.value[1].daysAgo(-1);
    picker.$emit('pick', [startTime, endTime]);
  }
}, {
  text: '« 往前一周 ',
  onClick: function onClick(picker) {
    var startTime = new _datetime.default(new _datetime.default().setHours(0, 0, 0));
    var endTime = new _datetime.default(new _datetime.default().setHours(23, 59, 59));

    if (!picker.value) {
      picker.value = [startTime.daysAgo(new _datetime.default().getDay()), endTime.daysAgo(new _datetime.default().getDay() + 1)];
    } else {
      picker.value = [picker.value[0].daysAgo(picker.value[0].getDay()), picker.value[1].daysAgo(picker.value[1].getDay() + 1)];
    }

    startTime = picker.value[0].daysAgo(7);
    endTime = picker.value[1];
    picker.$emit('pick', [startTime, endTime]);
  }
}, {
  text: ' 往后一周 »',
  onClick: function onClick(picker) {
    var startTime = new _datetime.default(new _datetime.default().setHours(0, 0, 0));
    var endTime = new _datetime.default(new _datetime.default().setHours(23, 59, 59));

    if (!picker.value) {
      picker.value = [startTime.daysAgo(new _datetime.default().getDay() - 7), endTime.daysAgo(new _datetime.default().getDay() - 6)];
    } else {
      picker.value = [picker.value[0].daysAgo(picker.value[0].getDay() - 7), picker.value[1].daysAgo(picker.value[1].getDay() - 6)];
    }

    startTime = picker.value[0];
    endTime = picker.value[1].daysAgo(-7);
    picker.$emit('pick', [startTime, endTime]);
  }
}];
exports.calendarMoveShortcuts = calendarMoveShortcuts;
var calendarShortcuts = [].concat(calendarBaseShortcuts, calendarMoveShortcuts);
exports.calendarShortcuts = calendarShortcuts;